export default {
  // 新闻资讯详情接口
  getNewsDetailById: '/amc/client/getImageTextContentById',
  // 新闻资讯相关推荐、热门评论
  getNewsOthersById: '/amc/client/getImageTextContentOthersById',
  // 完成学习
  finishStudy: '/amc/client/finishStudy',
  // 提交投票
  addBallotData: '/amc/client/addBallotData',
  // 验证是否已投票
  validateHasBallotOrNotByMember: '/amc/client/validateHasBallotOrNotByMember',
}